import React, { useContext, useEffect, useState } from "react";
import successIcon from "../../images/successGreenIcon.png";
import errorIcon from "../../images/errorRedIcon.png";
import LoadingIcon from "../../images/Loading_icon.gif";
import { ListDetailsContext } from "../../contexts/ListDetailsContext";
import { UrlContext } from "../../contexts/UrlContext";

export default function ExMaxWorkingDays({ maxWork, expert_id }) {
  const { tableData, setTableData } = useContext(ListDetailsContext);
  const [value, setValue] = useState("");
  const [returnSuccess, setReturnSuccess] = useState(false);
  const [returnError, setReturnError] = useState(false);
  const [showInvalidText, setShowInvalidText] = useState(false);
  const [loading, setLoading] = useState(false);
  const { API_URL } = useContext(UrlContext);

  useEffect(() => {
    setValue(maxWork);
  }, [maxWork]);

  const changeMaxWork = (newValue) => {
    if (newValue !== "" && (newValue < 1 || newValue > 4)) {
      setShowInvalidText(true);
      return;
    }
    setShowInvalidText(false);
    setReturnError(false);
    setLoading(true);
    const url = `${API_URL}update-max-work`;
    const data = {
      max_work: newValue,
      expert_id: expert_id,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.status === "success") {
          setReturnSuccess(true);
          setTimeout(() => {
            setReturnSuccess(false);
          }, 1500);
          setTableData(
            tableData.map((item) => {
              if (item.expert.ID === expert_id) {
                item.expert.max_working_days = newValue;
              }
              return item;
            })
          );
        } else {
          setReturnError(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        setReturnError(true);
        console.log(err);
      });
  };

  return (
    <>
      <i
        className="fa-regular fa-calendar-check"
        title="Max. working days per week"
        style={{ width: "6%" }}
      />
      <input
        type="number"
        placeholder="Max. working days per week"
        title="Max. working days per week"
        style={{ width: "94%" }}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onBlur={(e) => changeMaxWork(e.target.value)}
      />
      {showInvalidText && (
        <span className="max-working-invalid">
          Max working days should be 1 to 4
        </span>
      )}
      {loading && (
        <img
          className="return-msg-icon"
          style={{ top: "6px", right: "-17px" }}
          src={LoadingIcon}
          alt="loading"
          title="Loading..."
        />
      )}
      {returnSuccess && (
        <img
          className="return-msg-icon"
          style={{ top: "6px", right: "-17px" }}
          src={successIcon}
          alt="success"
          title="Success"
        />
      )}
      {returnError && (
        <img
          className="return-msg-icon"
          style={{ top: "6px", right: "-17px" }}
          src={errorIcon}
          alt="error"
          title="Error! Please reload"
        />
      )}
    </>
  );
}
